import { GetTopSubChart } from "./GetTopSubChart";

export function TestSubChartBreaksBelow(dbObj) {
  if (GetTopSubChart(dbObj) == 1) return true;
  else {
    var n = dbObj.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var child = dbObj.GetIndexChild(i);
      var testTop = TestSubChartBreaksBelow(child);
      if (testTop) return true;
    }
  }

  return false;
}
